<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :span="24">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">{{$t('model.application')}}</p>
              <div class="content">
                <div class="item">
                  <p class="name">{{$t('notAssociatedApplication')}}</p>
                  <router-link :to="{name: 'applications.new' }">
                    <el-button type="primary" style="width:initial">{{$t('createApplication')}}</el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class NoneRoleHome extends Vue {}
</script>
